// Error descriptions mapped to bit positions (from api/lib/models/thing_errors.py)
const ERROR_DESCRIPTIONS = {
    0: "LANGPAK error",
    1: "Flow meter malfunction",
    2: "Reserved",
    3: "Flash storage corrupted",
    4: "Low flow rate",
    5: "Dosing station jammed",
    6: "Boiler doesn't heat up",
    7: "Boiler overheat",
    8: "NFC malfunction",
    9: "Reserved",
    10: "Dosing station out of control",
    11: "TDS sensor malfunction",
    12: "IoT module malfunction",
    13: "Reserved",
    14: "External flash malfunction",
};

export const ErrorsDescription = ({errorMask1}) => {
    // Convert errorMask1 to a number if it's a string
    const mask = typeof errorMask1 === 'string' ? parseInt(errorMask1, 10) : errorMask1;

    // Handle invalid or missing mask
    if (!mask || mask === 0 || isNaN(mask)) {
        return <>No errors</>;
    }

    // Extract active error descriptions based on set bits
    const activeErrors = [];
    for (let bit = 0; bit < 15; bit++) {
        if (mask & (1 << bit)) {
            activeErrors.push(ERROR_DESCRIPTIONS[bit] || `Unknown error (bit ${bit})`);
        }
    }

    // Join with ' | ' separator
    return <>{activeErrors.join(' | ')}</>;
};